import React from 'react';

interface AdvantageItem {
  title: string;
  description: string;
}

export interface AdvantagesListProps {
  items?: AdvantageItem[];
}

const defaultAdvantages: AdvantageItem[] = [
  {
    title: "Широкий асортимент",
    description: "Понад 5000 найменувань металопрокату у наявності на складі"
  },
  {
    title: "Висока якість",
    description: "Вся продукція сертифікована та відповідає стандартам ГОСТ"
  },
  {
    title: "Швидка доставка",
    description: "Доставка по Києву та області протягом 24 годин"
  },
  {
    title: "Гнучкі умови",
    description: "Індивідуальний підхід і вигідні умови для кожного клієнта"
  }
];

const AdvantagesList: React.FC<AdvantagesListProps> = ({ items = defaultAdvantages }) => {
  return (
    <div className="advantages-list space-y-4">
      {items.map((item, index) => (
        <div key={index} className="advantage-item p-4 bg-gray-50 rounded-lg">
          <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
          <p className="text-gray-600">{item.description}</p>
        </div>
      ))}
    </div>
  );
};

export default AdvantagesList;